module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-1.2-BodyTalk[Port]-19f532ea86be779ea6724fd8f2b04b57.pdf";